import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { CurrentDataState } from '@records/state/current-data/current-data.state';
import { EntityType } from '@shared/models/entity-enum';
import { HierarchyType } from '@records/records-search/records-details/visual-widget/company-hierarchy-widget/company-hierarchy-widget.model';
import { isAnAliasManager } from '@shared/resolvers/user-info.resolver';

export const validateAliasManagerAccess = (hierarchyTypeDescription: string, currentEntityType: string): boolean => {
  if (
    currentEntityType?.toLowerCase() !== EntityType.Company ||
    hierarchyTypeDescription == null ||
    hierarchyTypeDescription === ''
  ) {
    return true;
  }

  if (hierarchyTypeDescription === HierarchyType.global || hierarchyTypeDescription === HierarchyType.operatingClient) {
    return false;
  }

  if (hierarchyTypeDescription === HierarchyType.alias) {
    return isAnAliasManager();
  } else {
    return true;
  }
};

@Injectable({
  providedIn: 'root',
})
export class CompanyTabAccessService {
  constructor(private store: Store) {}

  public checkAliasManagerAccess(record?: any): boolean {
    const companyRecord = record ?? this.store.selectSnapshot(CurrentDataState.record) ?? {};

    return validateAliasManagerAccess(companyRecord.hierarchy_type_desc, companyRecord?.entity?.entity_type);
  }

  public getHierarchyTypeDescription(): string | undefined {
    const { hierarchy_type_desc } = this.store.selectSnapshot(CurrentDataState.record) || {};
    return hierarchy_type_desc;
  }

  public getCurrentEntityType(): string | undefined {
    const { entity } = this.store.selectSnapshot(CurrentDataState.record) || {};
    return entity?.entity_type;
  }
}
